import { useEffect, ReactNode } from 'react';
import { useDesignStore } from '../store/designStore';
import { useConfigStore } from '../store/configStore';

export const ConfigProvider = ({ children, fallback = null }: { children: ReactNode; fallback?: ReactNode | null }) => {
    const configLoading = useConfigStore((state) => state.loading);
    const designLoading = useDesignStore((state) => state.loading);
    const configError = useConfigStore((state) => state.error);
    const designError = useDesignStore((state) => state.error);
    const config = useConfigStore((state) => state.config);
    const designConfig = useDesignStore((state) => state.config);

    useEffect(() => {
        const loadAllConfig = async () => {
            try {
                // Fetch both configuration and design configuration in parallel
                await Promise.all([useConfigStore.getState().fetchConfig(), useDesignStore.getState().fetchDesign()]);
            } catch (error) {
                console.error('Failed to fetch configurations in parallel:', error);
            }
        };

        void loadAllConfig();
    }, []);

    // Ensure that the component doesn't render until both config and design config are loaded
    if (configLoading || designLoading) {
        return fallback ?? <></>;
    }

    // If either fetch failed and left config as null, keep showing the fallback
    // rather than rendering children that would crash via useSafeConfig()
    if (configError || designError || !config || !designConfig) {
        return fallback ?? <></>;
    }

    return <>{children}</>;
};
